import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { Segment } from 'semantic-ui-react';
import { deleteCookie } from '../../../utils/ReadWriteCookie';

export const OCRHandoff = () => {
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();
    deleteCookie("ctxId");
    deleteCookie("X-Api-Key");

    const url = new URLSearchParams(window.location.search);
    const lang = url.get("lang");
    const ctxId = url.get("ctxId")
    const service = url.get("service");

    document.cookie = `ctxId=${ctxId};path=/;SameSite=Lax;`
    localStorage.setItem("handoff", "true")


    history.push(`/${ctxId}/${lang}/true${service !== null ? `/${service}` : ""}`);

  }, [])


  return (
    <Segment.Group className="containersegment" style={{ height: "100%", display: "flex" }}>
      <Segment loading style={{ flex: 1 }} />
    </Segment.Group>
  )
}
